export const routeBasePaths = {
  badGateway: '/badgateway',
  badRequest: '/badrequest',
  badRequestSimple: '/badrequestsimple',
  agentimportpermitfraud: '/report-select-agent-import-permit-fraud',
  childsupport: '/report-child-support',
  feedback: '/feedback',
  fraudwasteabuse: '/report-fraud-waste-abuse',
  fugitive: '/report-a-fugitive',
  grantcontractfraud: '/report-grant-contract-fraud',
  healthcare: '/report-healthcare-fraud',
  ihschildabuse: '/report-child-abuse-to-ihs',
  medicalidtheft: '/report-medical-identity-theft',
  opdiv: '/opdiv-referral',
  othercomplaint: '/report-other-complaint',
  qualityofcare: '/report-quality-of-care',
  whistleblower: '/report-whistleblower-retaliation'
}

export const routePaths = {
  badGateway: routeBasePaths.badGateway,
  badRequest: routeBasePaths.badRequest,
  badRequestSimple: routeBasePaths.badRequestSimple,
  agentimportpermitfraud: {
    confirmation: `${
      routeBasePaths.agentimportpermitfraud
    }/create-complaint/confirmation`,
    form: `${routeBasePaths.agentimportpermitfraud}/create-complaint`
  },
  childsupport: {
    confirmation: `${
      routeBasePaths.childsupport
    }/create-complaint/confirmation`,
    form: `${routeBasePaths.childsupport}/create-complaint`
  },
  feedback: {
    confirmation: `${routeBasePaths.feedback}/create-feedback/confirmation`,
    form: `${routeBasePaths.feedback}/create-feedback`
  },
  fraudwasteabuse: {
    confirmation: `${
      routeBasePaths.fraudwasteabuse
    }/create-complaint/confirmation`,
    form: `${routeBasePaths.fraudwasteabuse}/create-complaint`
  },
  fugitive: {
    confirmation: `${routeBasePaths.fugitive}/create-complaint/confirmation`,
    form: `${routeBasePaths.fugitive}/create-complaint`
  },
  grantcontractfraud: {
    confirmation: `${
      routeBasePaths.grantcontractfraud
    }/create-complaint/confirmation`,
    form: `${routeBasePaths.grantcontractfraud}/create-complaint`
  },
  healthcare: {
    confirmation: `${routeBasePaths.healthcare}/create-complaint/confirmation`,
    form: `${routeBasePaths.healthcare}/create-complaint`,
    identity: `${routeBasePaths.whistleblower}/identity`
  },
  ihschildabuse: {
    confirmation: `${
      routeBasePaths.ihschildabuse
    }/create-complaint/confirmation`,
    form: `${routeBasePaths.ihschildabuse}/create-complaint`
  },
  medicalidtheft: {
    confirmation: `${
      routeBasePaths.medicalidtheft
    }/create-complaint/confirmation`,
    form: `${routeBasePaths.medicalidtheft}/create-complaint`,
    identity: `${routeBasePaths.medicalidtheft}/identity`
  },
  opdiv: {
    base: routeBasePaths.opdiv,
    confirmation: `${routeBasePaths.opdiv}/confirmation`,
    form: `${routeBasePaths.opdiv}/create-complaint`
  },
  othercomplaint: {
    confirmation: `${
      routeBasePaths.othercomplaint
    }/create-complaint/confirmation`,
    form: `${routeBasePaths.othercomplaint}/create-complaint`
  },
  qualityofcare: {
    confirmation: `${
      routeBasePaths.qualityofcare
    }/create-complaint/confirmation`,
    form: `${routeBasePaths.qualityofcare}/create-complaint`
  },
  whistleblower: {
    confirmation: `${
      routeBasePaths.whistleblower
    }/create-complaint/confirmation`,
    eligibility: `${routeBasePaths.whistleblower}/eligibility`,
    form: `${routeBasePaths.whistleblower}/create-complaint`,
    identity: `${routeBasePaths.whistleblower}/identity`,
    base: routeBasePaths.whistleblower,
    process: `${routeBasePaths.whistleblower}/process`
  }
}
